var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppPageCard',{scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_vm._v(" Anggaran Belanjawan Mengurus")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }